// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { RatesRequestModel } from '../Classes/RatesRequestModel';
export class SyncDataRequest {
  userId: string;
  ratesRequest: RatesRequestModel;
}
